import { isInventoryQuestion } from '../../models/survey';
import { getQuestionsCollection } from '../../selectors/survey/pureSelectors';
import { CheckoutState } from '../../state';

export const hasInventoryQuestions = (state: CheckoutState) =>
    Object.values(getQuestionsCollection(state)).some((question) =>
        isInventoryQuestion(question.choices),
    );
